import React, { useState } from 'react';
import {
  Checkbox,
  TextField,
  IconButton,
  Tooltip,
  Modal,
  Box,
  Typography,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogActions,
} from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

// Styling for the modal
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto', // Allow scrolling if content overflows
};

const CustomComponent = ({
  index,
  dqRule,
  dqRules,
  setDqRules,
  handleGenerateRulesForEdit,
  formattedFields,
  setFormattedFields,
  headerName,
  setHeaderName,
  metricList,
  disableForm,
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleStatement = (event, index) => {
    const tempDqRules = dqRules.map((item) => {
      if (item.fieldId === dqRule.fieldId) {
        return { ...dqRule, statement: event.target.value };
      }
      return item;
    });
    setDqRules(tempDqRules);
  };

  const handleMetric = (event, index) => {
    const tempDqRules = dqRules.map((item) => {
      if (item.fieldId === dqRule.fieldId) {
        return { ...dqRule, metric: event.target.value };
      }
      return item;
    });
    setDqRules(tempDqRules);
  };

  const handleEdit = (event, index, dqRule) => {
    const tempDqRules = dqRules.map((item) => {
      if (item.fieldId === dqRule.fieldId) {
        return { ...dqRule, isDisabled: false };
      }
      return item;
    });
    setDqRules(tempDqRules);
  };

  const handleOpenDeleteModal = () => {
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    handleClose();
  };

  const handleDelete = (dqRule) => {
    setHeaderName(headerName.filter((item) => item.header !== dqRule.fieldName));
    setFormattedFields(formattedFields.filter((item) => item.fieldName !== dqRule.fieldName));
    setDqRules(dqRules.filter((item) => item.fieldId !== dqRule.fieldId));
  };

  const handleSave = (event, index, dqRule) => {
    const updatedDqRules = dqRules.map((item) => {
      if (item.fieldId === dqRule.fieldId) {
        return { ...dqRule, isDisabled: true };
      }
      return item;
    });
    handleGenerateRulesForEdit(dqRule, dqRule?.isCustomOrPredefined, true);
    setDqRules(updatedDqRules);
  };

  const handleIsChecked = (event, dqRule) => {
    const updatedDqRules = dqRules.map((item) => {
      if (item.fieldId === dqRule.fieldId) {
        return { ...dqRule, isChecked: event.target.checked };
      }
      return item;
    });
    setDqRules(updatedDqRules);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
        width: '100%',
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={dqRule?.isChecked}
            onChange={(event) => handleIsChecked(event, dqRule)}
            disabled={disableForm}
          />
        }
        sx={{ mr: 0, pr: 0 }}
      />

      <FormControl style={{ width: '20%', marginLeft: '2%' }} size="small">
        <InputLabel>Metric</InputLabel>
        <Select
          id="demo-simple-select-helper"
          name="metric"
          size="small"
          label="Metric"
          value={dqRule?.metric}
          onChange={(e) => handleMetric(e, index)}
          // key={data.id}
          disabled={dqRule?.isDisabled}
          sx={{ background: '#ffffff' }}
        >
          {metricList
            ?.sort((a, b) => a.metric_type?.localeCompare(b.metric_type))
            ?.map((item) => (
              <MenuItem key={item.rm_id} value={item.metric_type}>
                {item.metric_type}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <TextField
        variant="outlined"
        size="small"
        // name={dqRule.statement}
        // value={dqRule?.statement}
        value={dqRule?.statement}
        sx={{ marginLeft: '10px', flexGrow: 1 }}
        onChange={(e) => handleStatement(e, index)}
        disabled={dqRule?.isDisabled}
      />

      {/* Code Snippet Icon */}
      <Tooltip title="Open code snippet">
        <IconButton onClick={handleOpen} disabled={disableForm}>
          <CodeIcon />
        </IconButton>
      </Tooltip>

      {/* Edit Icon */}
      {dqRule.isDisabled ? (
        <Tooltip title="Edit">
          <IconButton onClick={(e) => handleEdit(e, index, dqRule)} disabled={disableForm}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Save">
          <IconButton onClick={(e) => handleSave(e, index, dqRule)} disabled={disableForm}>
            <SaveIcon />
          </IconButton>
        </Tooltip>
      )}

      {dqRule.validationStatus === 'warning' && dqRule.isDisabled ? (
        <Tooltip title="Warning">
          <IconButton disabled={disableForm}>
            <HourglassBottomIcon style={{ color: 'orange' }} />
          </IconButton>
        </Tooltip>
      ) : dqRule.validationStatus === 'success' && dqRule.isDisabled ? (
        <Tooltip title="Success">
          <IconButton disabled={disableForm}>
            <CheckCircleIcon style={{ color: 'green' }} />
          </IconButton>
        </Tooltip>
      ) : dqRule.validationStatus === 'failed' && dqRule.isDisabled ? (
        <Tooltip title="Failed">
          <IconButton disabled={disableForm}>
            <CancelIcon style={{ color: 'red' }} />
          </IconButton>
        </Tooltip>
      ) : null}

      <Tooltip title="Delete">
        <IconButton onClick={(e) => handleOpenDeleteModal()} disabled={disableForm}>
          <DeleteOutlineIcon />
        </IconButton>
      </Tooltip>

      {/* Modal for the Code Snippet */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">UDF (User Defined Function)</Typography>
            <IconButton onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">Code:</Typography>
            <Box
              sx={{
                maxHeight: '250px', // Set a maximum height for the box
                overflowY: 'auto', // Enable vertical scrolling if content overflows
                backgroundColor: '#f5f5f5',
                borderRadius: '4px',
                padding: '10px',
              }}
            >
              <pre
                style={{
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  padding: '10px',
                  whiteSpace: 'pre-wrap',
                  overflow: 'auto',
                  fontFamily: 'monospace',
                }}
              >
                {dqRule?.udfCode}
              </pre>
            </Box>
          </Box>
          {/* <Box mt={3} display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={handleClose}>
              Close
            </Button>
          </Box> */}
        </Box>
      </Modal>
      {openDeleteModal && (
        <Dialog
          open={openDeleteModal}
          onClose={handleCloseDeleteModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`Are you sure you want to delete?`}</DialogTitle>
          <DialogActions sx={{ justifyContent: 'center', marginBottom: '10px', marginTop: '-10px' }}>
            <Button
              variant="outlined"
              onClick={handleCloseDeleteModal}
              sx={{ textTransform: 'capitalize', color: '#43425D', border: '1px solid #43425D' }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => handleDelete(dqRule)}
              autoFocus
              sx={{
                backgroundColor: '#00043C',
                textTransform: 'capitalize',
                '&:hover': { backgroundColor: '#00043C' },
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};
// CustomComponent.propTypes = {
//   result: PropTypes.object,
// };

export default CustomComponent;
